<aside id="right_panel" class="nano affix sidebar_worker" ng-class="tab == 2 ? 'show-mobile-sidebar' : 'hide-mobile-sidebar'">
    <div class="sidebar-head" id="eRightPanel">
        <div class="sidebar-header p10" style="display:block;height: 30px;">
            <strong>Driver(s) </strong>
            <div class="pull-right">
                <a href="#" ng-if="selectedWorker.length" class="ml10" ng-click="makeArrived()" style="color:#fff">
                    Make Arrived {{ selectedWorker.length }} Worker(s)
                </a>
            </div>
        </div>

        <div class="sidebar-header p10" style="display:block">
            <input type="text" ng-model="filterData.searchTerm" placeholder="Search Driver(s)" class="form-control">
        </div>

        <ul class="sidebar-menu-tab mn pn">
            <li ng-class="statuses.worker == 0 ? 'active' : '' " ng-click="setStatus(0, 'worker')">
                <a href="#">
                    <h5 class="mbn mtn">{{ getSidebarWorkers(0, filterData.searchTerm).length }}</h5>
                    <small>Free</small>
                </a>
            </li>
            <li ng-class="statuses.worker == 1 ? 'active' : '' " ng-click="setStatus(1, 'worker')">
                <a href="#">
                    <h5 class="mbn mtn">{{ getSidebarWorkers(1, filterData.searchTerm).length }}</h5>
                    <small>Bussy</small>
                </a>
            </li>
            <li ng-class="statuses.worker == 2 ? 'active' : '' " ng-click="setStatus(2, 'worker')">
                <a href="#">
                    <h5 class="mbn mtn">{{ getSidebarWorkers(2, filterData.searchTerm).length }}</h5>
                    <small>All</small>
                </a>
            </li>
        </ul>
    </div>
    <div class="sidebar-block">
        <div 
            class="list-sidebar pn" 
            ng-repeat="worker in (getSidebarWorkers(statuses.worker, filterData.searchTerm) | filter: filterData.searchTerm)" 
            >
            <div class="row p10 mbn pbn">
                <div class="col-md-2">
                    <label class="block option option-primary mn">
                        <input type="checkbox" ng-click="addSelectedWorker(worker.id)" ng-checked="selectedWorker.indexOf(worker.id) > -1 || master" id="checkboxDefault-{{worker.id}}">
                        <span class="checkbox mn"></span>
                    </label>
                </div>
                <div class="col-md-10 pl5" ng-click="openRouteDetail(worker)">
                    <strong class="order-list-time">
                        {{ worker.user.full_name }}
                        <span 
                            style="background-color: #469aa7" 
                            class="order-list-status pull-right">
                            {{ getWorkerOrderCount(worker) }}
                        </span>
                    </strong>
                    <p class="order-list-address mb5">
                        {{ worker.phone_number }}
                        <img src="/img/vehicle/{{worker.vehicle}}.svg" alt="" width="28">

                        <i class="fa fa-circle pull-right text-default fs12" ng-if="worker.status == 0 && !checkLastLocationTime(worker)"></i>
                        <i class="fa fa-circle pull-right text-success fs12" ng-if="worker.status == 1 && !checkLastLocationTime(worker)"></i>
                        <i class="fa fa-warning pull-right fs18 text-danger" ng-if="checkLastLocationTime(worker)"></i>
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="sidebar-head" ng-if="sWorker">
        <div class="sidebar-header" style="padding:5px 10px; background:#469aa7; height: 90px;display:block">
            <div class="row pt10">
                <div class="col-md-3 col-sm-3 col-xs-3">
                    <img ng-src="https://tookan.s3.amazonaws.com/fleet_thumb_profile/user.png" alt="Image" class="img-circle mw40 mt10" err-src="app/img/default-user.png" src="https://tookan.s3.amazonaws.com/fleet_thumb_profile/user.png">
                </div>
                <div class="col-md-9 col-sm-8 col-xs-8">
                    <div class="row">
                        <strong>{{ sWorker.user.full_name }}</strong>
                        <a href="#" ng-click="closeWorker()" class="pull-right" style="color:#fff"><i class="fa fa-close"></i></a>
                    </div>
                    <div class="row">
                        <small class="fs12"> {{ Number(sWorker.on_way_orders.length) + Number(sWorker.completed_orders.length) }} | <strong>#{{ sWorker.id }}</strong> </small>
                    </div>
                </div>
            </div>
        </div>

        <div class="sidebar-header" style="height: 50px">
            <div class="row">
                <div class="col-md-12">
                    <div class="row mt10">
                        <strong><i class="fa fa-phone"></i> {{ sWorker.phone_number }} </strong>
                        <span class="badge badge-success pull-right" ng-if="sWorker.status == 1">Online</span>
                        <span class="badge badge-default pull-right" ng-if="sWorker.status != 1">Offline</span>      
                    </div>
                </div>
            </div>
        </div>

        <ul class="list-group">
            <!-- <li class="list-group-item">
                <small>Şarj : </small>
                <strong>{{ getBatteryInfo(sWorker) }} %</strong>
            </li> -->
            <li class="list-group-item">
                <small>Device : </small>
                <strong>{{ sWorker.device.length > 0 ? sWorker.device : 'N/A' }}</strong>
            </li>
            <li class="list-group-item">
                <small>Model : </small>
                <strong>{{ sWorker.phone_model.length > 0 ? sWorker.phone_model : 'N/A' }}</strong>
            </li>
            <li class="list-group-item" ng-if="authenticatedUser.setting.last_location_time">
                <small>Last Location </small>
                <strong>{{ getLastLocationTime(sWorker) }}</strong>
            </li>
        </ul>
    </div>
    
    <div 
        class="sidebar-block"
        ng-class="authenticatedUser.setting.last_location_time ? 'top250' : 'top200'" 
        ng-if="sWorker">
        <div class="list-sidebar pn" ng-repeat="order in data.orders | filter:getWorkerOrders " ng-click="clickWork(order)">
            <div class="p10 mbn  ">
                <strong class="order-list-time">
                    {{ order.scheduled_time | amUtc | amDateFormat:'HH:mm' }} - {{ order.scheduled_time | amUtc | amDateFormat:'DD MMM YYYY' }}

                    <span ng-if="order.status" 
                        ng-style="{'background-color': order.status.color }" 
                        class="order-list-status pull-right">
                        {{ order.status.name }}</span>
                    <span ng-if="!order.status"  
                        class="pull-right">
                        Created</span>
                </strong> 
                <strong class="order-list-time clearfix mt5 mb5">
                    {{ order.customer.customer_name }}
                </strong>
                <p class="order-list-address mt5">
                    {{ order.customer.address }}
                </p>
            </div>
        </div>
    </div>
</aside>